import { getTops2Token } from "./TokenService";

const getFolderInfByFolderID = async (folderId) => {
  const url = `https://api-test.cbre.com:443/t/vas_global/dev/common-ol/box/getFolderBySharedLinkOrFolderID/${folderId}`;
  const token = await getTops2Token();
  console.log(`Fetching folder info for ID: ${folderId}`);
  
  if (!token) {
    throw new Error('No token available');
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Azuretoken': token,
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('API Error:', errorText);
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  const data = await response.json();
  return data;
}

export {
  getFolderInfByFolderID,
};